import React from 'react'

function Membership(props) {
  // console.log(props.data.membership)
  return (
    <div>
         <div className='  ' style={{ width: '100%' }}>

<h1 className=' text-[1.7rem] mt-[2rem]' id='edu'>Membership</h1>

{props.data.membership?.map((r,t)=>{
  return(
<>
<div className='flex  items-center justify-between mt-7' style={{ width: '100%' }} >
    <div className='edu1'>{r.name} at {r.memberType}

    </div>
    <div className='edu2'>{r.awardedYear} </div>
</div>
<hr className='facultyHr' />





</>

  )
})}

</div>
    </div>
  )
}

export default Membership